import { Component, Input, OnInit} from '@angular/core';
import {DocumentoPac} from 'src/app/model/DocumentoPac';
import {EquipamentoService} from 'src/app/services/equipamento.service';
import { Equipamento } from 'src/app/model/Equipamentos';
import { Fornecedor } from 'src/app/model/Fornecedor';

@Component({
  selector: 'app-informacoes-equipamentos',
  templateUrl: './informacoes-equipamentos.component.html',
  styleUrls: ['./informacoes-equipamentos.component.scss'],
  standalone: false
})
export class InformacoesEquipamentosComponent implements OnInit {

  @Input()
  documentoPac: DocumentoPac = new DocumentoPac();
  listaFornecedores : Fornecedor []=[];
  constructor(private equipamentoService : EquipamentoService) { }

  ngOnInit(): void {
    
      this.equipamentoService.obterEquipamentos(this.documentoPac.id).subscribe(
        (equipamentos) =>{          
          let listaEquipamentos : Equipamento[]=[];
          listaEquipamentos = equipamentos;
          this.filterFabricantes(listaEquipamentos);
        },
        (error)=>{
          console.error(`Erro ao pesquisar lista de equipamentos: ${error}`);
        }
      );
   
  }

  public getValorUnitarioTotalEquipamento(equipamento : Equipamento){
    return Number(equipamento.valorTotal)/equipamento.quantidade;
  }

  public getValorUnitarioFinanciadoEquipamento(equipamento : Equipamento){
    return Number(equipamento.valorTotalFinanciado)/equipamento.quantidade;
  }

  private filterFabricantes(listaEquipamentos : Equipamento[]){

      listaEquipamentos.filter(equip => {     
      let fornececedorTemp : Fornecedor = new Fornecedor();
      let fornececedoresFilter : Fornecedor [];
      
      fornececedorTemp.cnpj = equip.cnpjFornecedor;
      fornececedorTemp.nome = equip.nomeFornecedor;

      fornececedoresFilter = this.listaFornecedores.filter(forn =>forn.cnpj == equip.cnpjFornecedor);
      
      if (fornececedoresFilter && fornececedoresFilter.length > 0) {
        fornececedorTemp = fornececedoresFilter[0];

        fornececedorTemp.equipamentosList.push(equip);
      } else {
        fornececedorTemp.equipamentosList.push(equip);

        this.listaFornecedores.push(fornececedorTemp);
      }
         
   });
  }
}